import { render, staticRenderFns } from "./SewipPatients.vue?vue&type=template&id=0c4aa8c9&scoped=true&lang=pug&"
import script from "./SewipPatients.vue?vue&type=script&lang=ts&"
export * from "./SewipPatients.vue?vue&type=script&lang=ts&"
import style0 from "./SewipPatients.vue?vue&type=style&index=0&id=0c4aa8c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4aa8c9",
  null
  
)

export default component.exports